import { EntrepriseBase } from 'src/app/data/intervenant/models/entreprise-base.model';
import { ClassConverterFactory } from '../../../../core/services/mapper/data-property.converter';

export class EngagementDetail {
    static jsonMap = {
        id: { key: 'id', optional: true },
        entreprise: { key: 'entreprise', converter: new (ClassConverterFactory.build(EntrepriseBase))() },
        activiteProduction: { key: 'activiteProduction' },
        activiteConditionnement: { key: 'activiteConditionnement' },
        engagementVergersEcoresponsables: { key: 'engagementVergersEcoresponsables' },
        engagementGlobalGap: { key: 'engagementGlobalGap' },
        engagementHve: { key: 'engagementHve' },
        certificationBrc: { key: 'certificationBrc' },
        certificationIfs: { key: 'certificationIfs' },
        typeEngagementHve: { key: 'typeEngagementHve', optional: true }
    };

    public id: number = undefined;
    public entreprise: EntrepriseBase = undefined;
    public activiteProduction: boolean = undefined;
    public activiteConditionnement: boolean = undefined;
    public engagementVergersEcoresponsables: boolean = undefined;
    public engagementGlobalGap: boolean = undefined;
    public engagementHve: boolean = undefined;
    public certificationBrc: boolean = undefined;
    public certificationIfs: boolean = undefined;
    public typeEngagementHve: string = undefined;
}
